/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { createSelector } from 'reselect';
import config from 'loracfg';

const wsUrl = (appId, token) => {
  const { protocol, hostname } = document.location;
  let path = config.wsBase;
  if (!path.startsWith('ws')) {
    // for production
    if (protocol === 'https:') {
      path = `wss://${hostname}${path}`;
    } else {
      path = `ws://${hostname}${path}`;
    }
  }
  return `${path}/application/ws?appeui=${appId}&token=${token}&order=desc`;
};

const httpUrl = (appId, token) => {
  const { protocol, hostname } = document.location;
  let path = config.apiBase;
  if (!path.startsWith('http')) {
    // for production
    if (protocol === 'https:') {
      path = `https://${hostname}${path}`;
    } else {
      path = `http://${hostname}${path}`;
    }
  }
  return `${path}/application/data?appeui=${appId}&token=${token}&order=desc`;
};

export const tokensSelector = appId => createSelector(
  state => state.app.getTokens,
  (tokens) => {
    if (tokens.status !== 'success') {
      return tokens;
    }
    return {
      ...tokens,
      data: {
        ...tokens.data,
        list: tokens.data.list.map((token) => {
          let displayName = token.name;
          if (displayName === token.token) {
            displayName = `${token.name.substr(0, 5)}...${token.name.substr(token.name.length - 5)}`;
          }
          return {
            ...token,
            displayName,
            wsurl: wsUrl(appId, token.token),
            httpurl: httpUrl(appId, token.token),
            note: JSON.parse(token.aux || '{}').note,
          };
        }),
      },
    };
  },
);




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/APIView/coms/PullInterfaces/selectors.js